<template>
    <div>
        <modal-crear-editar :configuracion="configuracion_modal" @realizado="restablecer_inputs"></modal-crear-editar>
        <tablita @cargar="cargar($event)" @cargar_url="cargar_url($event)" @guardar="guardar($event)" :configuracion="configuracion_tabla"></tablita>
    </div>
</template>
<script>
import { mapActions, mapState } from 'vuex';
import ModalCrearEditar from '../../components/Modal/ModalEditarCrear'
import Tabla from '../../components/Tabla/Tabla'
//import lenguaje from '../../config/es_datatable.json'
export default {
    data:()=>({
        filter:'',
        columnas:[
          {key:'fecha_hora_ticket',label:'Fecha Ticket',busqueda:'',tipo:'datetime',searchable:true,path:'fecha_hora_ticket'},
          {key:'codigo_ticket',label:'Ticket',busqueda:'',tipo:'string',searchable:true,path:'codigo_ticket'},
          {key:'guias_id',label:'Guía',busqueda:'',tipo:'select-loadable',ruta:'/guias',parametro:'numero_guia',searchable:true,path:'guia.numero_guia',opciones:[],valor_opcion:'id',label_opcion:'numero_guia'},
          //{key:'tickets_id',label:'Ticket',busqueda:'',tipo:'select-loadable',ruta:'/tickets',parametro:'codigo_ticket',searchable:true,path:'ticket_texto',opciones:[],valor_opcion:'id',label_opcion:'codigo_ticket'},
          {key:'empresa',label:'Empresa',busqueda:'',tipo:'string',searchable:true,path:'empresa'},
          {key:'sucursal',label:'Sucursal',busqueda:'',tipo:'string',searchable:true,path:'sucursal'},
          {key:'destino',label:'Destino',busqueda:'',tipo:'string',searchable:false,path:'destino_distribucion'},
          {key:'peso_real_distribucion',label:'Cantidad (Kg)',busqueda:'',tipo:'string',searchable:false,path:'peso_real_distribucion'},
          {key:'vertederos_id',label:'Seleccione Vertedero Destino',busqueda:'',tipo:'select-editable',ruta:'/vertederos',parametro:'nombre',searchable:true,path:'vertedero_texto',opciones:[],valor_opcion:'id',label_opcion:'nombre'}

        ],
        botones:[
          //{label:'Editar',clase:'btn-warning',evento:'editar',icono:'fa fa-pen'}
          {label:'guardar',clase:'btn-success',evento:'guardar',icono:'fas fa-save'}
        ],
        lista:[],
        links:[],
        tickets:[],
        restricciones:[],
        inputs:[
          /* {cols:4,tipo:'numero',key:'codigo_ticket',valor:'',label:'N° Ticket (*)'},
          {cols:4,tipo:'select',key:'ciclo_ticket',valor:'',label:'Ciclo ticket (*)',opciones:[],valor_opcion:'id',label_opcion:'nombre'} */
        ],
        configuracion_modal:{
          titulo:'',
          ancho:'xl',
          ruta:'/guias',
          tipo_ruta:'post',
          titulo_boton:'Crear',
          clase_boton:'btn-success'
        },
        configuracion_tabla:{
          titulo:'MATERIA PRIMA A VERTEDERO',
          titulo_boton:'',
          clase_boton:'',
          btn_nuevo:false
        },
        pagina_actual:'',
        vertederos:[]
    }),
    mounted() {
        /* $('#empresas').DataTable({
            language: lenguaje
        }); */
        this.cargar_vertederos();
    },
    methods: {
        async cargar_vertederos(){
          await this.axios.get(`${this.api}/vertederos?limit=9999999`,this.cabeceras_json).then((res)=>{
            this.vertederos = res.data.data.data;
            this.$set(this.columnas[7],'opciones',this.vertederos);
            //this.$set(this.inputs[2],'opciones',this.ciclos_ticket);
            ////console.log('tickets',res.data.data);
          }).catch((e)=>{
            //console.log(e);
          });
          this.cargar('?');
        },

        async cargar($event){
          //console.log('cargando',$event);
          if(!$event.includes('&destino=3,4')){
            $event+='&destino=3,4'; // 3 = Vertedero 4 = otro
          }
          //$event = $event.replace('?','?destino=5');
          this.pagina_actual = `${this.api}/distribucion_vista${$event}`;
          this.lista = [];
            await this.axios.get(`${this.api}/distribucion_vista${$event}`,this.cabeceras_json).then((res)=>{
                this.lista = res.data.data.data;
                this.links = res.data.data.links;
                /* let config = {
                  columnas:this.columnas,
                  lista:this.lista,
                  links:this.links
                } */
                this.inicializar_tabla({
                  columnas:this.columnas,
                  lista:this.lista,
                  links:this.links,
                  botones:this.botones
                });
                this.$emit('generar',this.columnas,this.lista);
                ////console.log('listado',res.data.data.data);
                //$('#empresas').DataTable().draw();
            }).catch(e=>{
                //alert(e);
            })
        },
        async cargar_url(url){
          if(url){
            this.pagina_actual = url;
            await this.axios.get(url,this.cabeceras_json).then((res)=>{
                this.lista = res.data.data.data;
                this.links = res.data.data.links;
                ////console.log('listado',res.data.data.data);
                this.setear_lista({lista:this.lista,links:this.links});
                //$('#empresas').DataTable().draw();
            }).catch(e=>{
                //alert(e);
            })
          }
          
        },

        async guardar($event){
          let id = $event.item.guia_distribucion_id;
          let body = {
            id:id,
            vertederos_id:$event.item.vertederos_id
          }

          await this.axios.post(`${this.api}/guia_distribucion/${id}/enviar_a_vertedero`,body,this.cabeceras_json).then((res)=>{
            //console.log('enviado a vertedero',res.data);
          }).catch((e)=>{
            //console.log(e);
          })
            //console.log('guardando',$event);
        },
        
        restablecer_inputs(){
          this.cargar_url(this.pagina_actual);
          this.inputs.forEach(i => {
            i.valor = '';
          });
          this.setear_inputs(this.inputs);
        },

        /* ver_documento(event){
          window.open(`${event.item.url}`, '_blank');
        }, */
        ...mapActions(['inicializar_tabla','setear_lista','setear_inputs'])
    },
    components:{
        'modal-crear-editar':ModalCrearEditar,
        'tablita':Tabla
    },
    computed:{
        ...mapState(['api','api_public','cabeceras_json']),
        query(){
          let string = '?';
          let and = '';
          let total = this.columnas.length - 1;
          this.columnas.forEach((c,index) => {
            if(index > 0 && string.length>0){
              and = '&';
            }else if(index == total){
              and = '';
            }

            if(c.busqueda != ''){
              string += `${and}${c.key}=${c.busqueda}`;
            }
          });
          return string;
        },

        
    }
}
</script>
<style>
  .form-control{
    height: calc(1em + 1.25rem + 5px);
  }
</style>